import React, {useState} from 'react';

import { Modal } from 'react-bootstrap';

type Props = {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

const VendorDeactivationWarningModal = ({onConfirm, onCancel}:Props) => {
  const [isDeactivating, setIsDeactivating] = useState(false);

  const handleDeactivate = async () => {
    setIsDeactivating(true);

    await onConfirm();
  }

  return <Modal show>
    <Modal.Header>
      <b>Vendor deactivation</b>
    </Modal.Header>
    <Modal.Body>
      <div className={'alert alert-warning'}>
        <h4>WARNING:</h4>
        <p>Deactivating this vendor will immediately remove them from the Batch platform. Please only use this for vendors who want to be permanently removed from Batch.</p>
        <br/>
        <p>Are you sure you wish to proceed?</p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button
        className={`btn btn-danger ${isDeactivating ? 'btn-loading' : ''}`}
        type='button'
        onClick={handleDeactivate}
        disabled={isDeactivating}
      >
        {isDeactivating ? 'Deactivating...' : 'Yes, deactivate'}
      </button>
      <button
        className='btn'
        type='button'
        onClick={onCancel}
      >
        No
      </button>
    </Modal.Footer>
  </Modal>
}

export default VendorDeactivationWarningModal;